"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserUnseenCountByEPLs = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var api_1 = tslib_1.__importDefault(require("./api"));
var SIXTY_SECONDS = 60000;
var axiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    baseURL: process.env.REACT_APP_MESSAGING_SERVICE_URL,
    responseType: 'json',
});
axiosInstance.interceptors.request.use(function (request) {
    request.headers.Authorization = tokenStorage_1.default.get();
    return request;
});
axiosInstance.interceptors.response.use(function (response) {
    if (response.data === undefined)
        return response;
    return response.data;
}, function (error) {
    return Promise.reject(error);
});
var getUserUnseenCountByEPLs = function (userId, eplIds) {
    return axiosInstance.post('/get-user-unseen-count-batch', { userId: userId, eplIds: eplIds });
};
exports.getUserUnseenCountByEPLs = getUserUnseenCountByEPLs;
